import React from 'react';
import { Alert } from 'reactstrap';

const NoDataFound = ({ message, className = '' }) => {
  return (
    <Alert
      className={`border-0 rounded-0 text-center mb-0 ${className}`}
      color="danger"
    >
      {message}
    </Alert>
  );
};

export default NoDataFound;
